var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCountryParam } from "@/hooks/useCountryParam";
import { isJobDatePostedValue } from "@/types/SearchData";
import { SearchParamType } from "@/types/SearchParamType";
import { Button, HStack, Text, VStack } from "@chakra-ui/react";
import { faCalendarDays, faTriangleExclamation, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Dropdown } from "@/components/Dropdown";
var ANY_TIME_LABEL = "Any time";
function useDisplayOptions(options, country) {
    var _a = useState({ country: country, options: options }), cachedOptions = _a[0], setCachedOptions = _a[1];
    useEffect(function () {
        if (options !== undefined) {
            setCachedOptions({ country: country, options: options });
        }
    }, [country, options]);
    return (options !== null && options !== void 0 ? options : (cachedOptions.country === country ? cachedOptions.options : undefined));
}
export function DatePostedFilter(_a) {
    var _b, _c, _d;
    var options = _a.options;
    var _e = useSearchParams(), searchParams = _e[0], setSearchParams = _e[1];
    var country = useCountryParam();
    var selectedValue = searchParams.get(SearchParamType.DATE_POSTED);
    var displayOptions = useDisplayOptions(options, country);
    var supportedOptions = displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.filter(function (option) {
        return isJobDatePostedValue(option.value);
    });
    var selectedOption = supportedOptions === null || supportedOptions === void 0 ? void 0 : supportedOptions.find(function (option) { return option.value === selectedValue; });
    var hasLoadedOptions = options !== undefined;
    var isUnavailable = hasLoadedOptions && selectedValue !== null && selectedOption === undefined;
    if (!selectedValue && (!supportedOptions || supportedOptions.length === 0)) {
        return null;
    }
    var labels = __spreadArray([
        ANY_TIME_LABEL
    ], ((_b = supportedOptions === null || supportedOptions === void 0 ? void 0 : supportedOptions.map(function (option) { return option.label; })) !== null && _b !== void 0 ? _b : []), true);
    var selectedLabel = (_d = (_c = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _c !== void 0 ? _c : (isUnavailable ? "Unavailable" : selectedValue)) !== null && _d !== void 0 ? _d : ANY_TIME_LABEL;
    var updateSelection = function (value) {
        var updatedParams = new URLSearchParams(searchParams);
        if (value) {
            updatedParams.set(SearchParamType.DATE_POSTED, value);
        }
        else {
            updatedParams.delete(SearchParamType.DATE_POSTED);
        }
        updatedParams.delete(SearchParamType.CURSOR);
        updatedParams.delete(SearchParamType.JOB_KEY);
        if (country) {
            updatedParams.set(SearchParamType.COUNTRY, country);
        }
        setSearchParams(updatedParams);
    };
    var handleChange = function (label) {
        var _a;
        if (typeof label !== "string")
            return;
        var option = supportedOptions === null || supportedOptions === void 0 ? void 0 : supportedOptions.find(function (candidate) { return candidate.label === label; });
        updateSelection((_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : null);
    };
    return (_jsxs(VStack, __assign({ alignItems: "start", gap: "1", w: "100%", css: { "& > button": { w: "100%" } } }, { children: [_jsx(Dropdown, { icon: _jsx(FontAwesomeIcon, { icon: faCalendarDays }), label: "Date posted: ", buttonName: "Date posted", optionsName: SearchParamType.DATE_POSTED, menuTitle: "Date posted", selectedValue: selectedLabel, values: labels, handleChange: handleChange }), isUnavailable && (_jsxs(HStack, __assign({ alignItems: "start", gap: "2", w: "100%", px: "2", py: "1", borderRadius: "sm", bg: "orange.50", color: "orange.800", role: "status" }, { children: [_jsx(FontAwesomeIcon, { icon: faTriangleExclamation }), _jsx(Text, __assign({ fontSize: "xs", lineHeight: "short" }, { children: "This date filter is no longer available. Remove it to choose a current date range." })), _jsx(Button, __assign({ size: "xs", variant: "plain", minW: "fit-content", h: "auto", p: "0", color: "blue.700", fontSize: "xs", textDecoration: "underline", textUnderlineOffset: "2px", "aria-label": "Remove filter: Date posted", onClick: function () { return updateSelection(null); } }, { children: "Remove filter" }))] })))] })));
}
